import { render, staticRenderFns } from "./AdminFaqCategoryNew.vue?vue&type=template&id=20330276&scoped=true"
import script from "./AdminFaqCategoryNew.vue?vue&type=script&lang=js"
export * from "./AdminFaqCategoryNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20330276",
  null
  
)

export default component.exports